module.exports = __webpack_public_path__ + "img/team.8dcbc6f9.png";